import { useNavigate } from 'react-router'
import { OnboardingShell } from '@/onboarding/OnboardingShell'
import { bookmarkStep } from '@/api/onboarding'

const STEPS = [
  { name: 'Подключим канал или группу', time: '≈ 2 мин' },
  { name: 'Выберем, что хотите запустить', time: '≈ 30 сек' },
  { name: 'Подключим Я.Директ и аналитику', time: '≈ 2 мин' },
  { name: 'Соберём первые креативы', time: '≈ 3 мин' },
  { name: 'Включим тариф и поедем', time: '≈ 2 мин' },
]

export function OverviewPage() {
  const navigate = useNavigate()

  function handleContinue() {
    bookmarkStep('source')
    navigate('/onboarding/source')
  }

  return (
    <OnboardingShell
      step="overview"
      footer={
        <>
          <button className="foot-back" onClick={() => navigate('/onboarding')}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15 18l-6-6 6-6" />
            </svg>
            Назад
          </button>
          <div className="foot-spacer" />
          <button className="foot-skip" onClick={() => navigate('/dashboard')}>
            Пропустить онбординг
          </button>
          <button className="foot-next" onClick={handleContinue}>
            Продолжить
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 6l6 6-6 6" />
            </svg>
          </button>
        </>
      }
    >
      <div className="ten-min-hero">
        <p className="stage-eyebrow center">
          <span className="stage-eyebrow-pill">Запуск за 10 минут</span>
        </p>
        <h1 className="stage-title center">
          5 шагов до первой кампании, <em>и&nbsp;вы&nbsp;в&nbsp;деле</em>.
        </h1>
        <p className="stage-sub center">
          Вместе настроим сервис под ваш проект. Не&nbsp;хочется проходить весь путь&nbsp;— пропустите и соберите кабинет позже.
        </p>

        <ol className="ten-min-steps">
          {STEPS.map((s, i) => (
            <li key={i}>
              <div className="ten-step-num">{i + 1}</div>
              <div className="ten-step-name">{s.name}</div>
              <div className="ten-step-time">{s.time}</div>
            </li>
          ))}
        </ol>
      </div>

      <style>{`
        .ten-min-hero {
          max-width: 760px;
          margin: 32px auto 0;
        }
        .ten-min-steps {
          list-style: none;
          margin: 32px 0 0;
          padding: 0;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .ten-min-steps li {
          display: grid;
          grid-template-columns: 40px 1fr auto;
          gap: 18px;
          align-items: center;
          padding: 18px 24px;
          background: var(--tg-surface, #fff);
          border: 1px solid var(--tg-line-2, #f0f0f4);
          border-radius: 12px;
          transition: border-color 200ms;
        }
        .ten-min-steps li:hover {
          border-color: rgba(0, 128, 255, 0.3);
        }
        .ten-step-num {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: var(--tg-blue-bg, #ebf2ff);
          color: var(--tg-blue-press, #0066cc);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 800;
          font-size: 16px;
        }
        .ten-step-name {
          font-weight: 600;
          font-size: 16px;
          color: var(--tg-ink, #111);
        }
        .ten-step-time {
          font-size: 12px;
          color: var(--tg-mute, #8f9eb0);
          font-weight: 600;
          font-variant-numeric: tabular-nums;
        }
      `}</style>
    </OnboardingShell>
  )
}
